export function generateDefaultSearchData() {
    return {
        jobs: [],
        pageCursors: new Map(),
    };
}
